// Shared JavaScript for all roles
// This file contains common utilities and functions used across the application

import { createApp } from 'vue'

// Set document.domain early (must run before other cross-domain operations)
import '../shared/document-domain.js'

// Load Quest configuration from server
import '../shared/config-loader.js'

// Load MathJax configuration (must run before MathJax library loads)
import '../shared/mathjax-config.js'

// Import quest.js (shared by all roles)
import '../shared/quest.js'

// Export createApp so other entry points can use it
export { createApp }

// Common utilities that all roles need
export function initializeCommonFeatures() {
  // Add any common initialization here
  console.log('Quest application initialized')
}

// Initialize common features on page load
document.addEventListener('DOMContentLoaded', () => {
  initializeCommonFeatures()
})
